// Shared by the Contributions/Distributions plot box and the Investor Cash Flows grid body so the two line up.
export const SummaryPanelBodyHeight = '25rem';
